import { render } from "./TagRelationTypeColumn.vue?vue&type=template&id=ec0c3434&scoped=true"
import script from "./TagRelationTypeColumn.vue?vue&type=script&lang=js"
export * from "./TagRelationTypeColumn.vue?vue&type=script&lang=js"

import "./TagRelationTypeColumn.vue?vue&type=style&index=0&id=ec0c3434&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec0c3434"]])

export default __exports__